import { Controller } from "stimulus"
import noUiSlider from 'nouislider';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['slider', 'search', 'interestedIn']

  connect() {
    this.initializeSlider()
  }

  initializeSlider() {
    const singlesAgeSlider = this.sliderTarget

    noUiSlider.create(singlesAgeSlider, {
      start: [18, 65], // Handle start position
      step: 1, // Slider moves in increments of '1'
      margin: 2, // Handles must be more than '2' apart
      connect: true, // Display a colored bar between the handles
      orientation: 'horizontal', // Orient the slider vertically
      behaviour: 'drag', // Move handle on tap, bar is draggable
      tooltips: true, // Use tooltips to show values (overridden in css unless handle is active)
      format: { // Format without decimals
        from: function(val) {
          return parseInt(val)
        },
        to: function(val) {
          return parseInt(val)
        }
      },
      range: {
        'min': 18,
        'max': 65
      },
      pips: {
        mode: 'values',
        density: 47,
        values: [18, 65]
      } // show starting and ending values at ends of slider
    });

    // Add "+" to 65
    $('.noUi-pips').children().last().text('65+')
    // Add action to slider handles
    $('.noUi-handle').attr('data-action', 'mousedown->singles#slideHack')
  }

  // mouseup doesn't work if mouse moves off of target before mousing up...hence the hack
  slideHack() {
    $(document).on('mouseup', () => this.filterSingles())
  }

  filterSingles() {
    $(document).off('mouseup') // Disable mouseups from happening willy nilly

    const singlesAgeSlider = this.sliderTarget
    const searchInput = $(this.searchTarget).val()
    const ageValues = singlesAgeSlider.noUiSlider.get()
    const interestedInValue = $(this.interestedInTarget).val()

    if (ageValues[1] == "65") {
      setTimeout(()=> {
        $.get({
          dataType: 'script',
          url: '/dating',
          data: {
            fancies: interestedInValue,
            q: {
              full_name_cont: searchInput,
              birthday_lteq: moment().subtract(ageValues[0], 'years').format('MMMM DD YYYY')
            }
          }
        })
      }, 1000)
    } else {
       setTimeout(() => {
        $.get({
          dataType: 'script',
          url: '/dating',
          data: {
            fancies: interestedInValue,
            q: {
              full_name_cont: searchInput,
              birthday_gteq: moment().subtract(ageValues[1], 'years').format('MMMM DD YYYY'),
              birthday_lteq: moment().subtract(ageValues[0], 'years').format('MMMM DD YYYY')
            }
          }
        })
       }, 1000)
    }
  }

}